import {
  USER_ID_PRODUCTIVITY_FAIL,
  USER_ID_PRODUCTIVITY_SUCCESS,
  USER_ID_PRODUCTIVITY_REQUEST,
  USER_MONTH_PRODUCTIVITY_REQUEST,
  USER_MONTH_PRODUCTIVITY_SUCCESS,
  USER_MONTH_PRODUCTIVITY_FAIL,
  USER_PREV_PRODUCTIVITY_FAIL,
  USER_PREV_PRODUCTIVITY_REQUEST,
  USER_PREV_PRODUCTIVITY_SUCCESS,
  USER_TODAY_ALL_PRODUCTIVITY_FAIL,
  USER_TODAY_ALL_PRODUCTIVITY_REQUEST,
  USER_TODAY_ALL_PRODUCTIVITY_SUCCESS,
  USER_MONTH_ALL_PRODUCTIVITY_FAIL,
  USER_MONTH_ALL_PRODUCTIVITY_REQUEST,
  USER_MONTH_ALL_PRODUCTIVITY_SUCCESS,
  USER_TODAY_ALL_FOR_REPORT_PRODUCTIVITY_FAIL,
  USER_TODAY_ALL_FOR_REPORT_PRODUCTIVITY_REQUEST,
  USER_TODAY_ALL_FOR_REPORT_PRODUCTIVITY_SUCCESS,
} from '../../types/admin/productTypes';

export const productReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_PRODUCTIVITY_REQUEST:
      return {
        ...state,
        proLoadings: true,
      };
    case USER_ID_PRODUCTIVITY_SUCCESS:
      return {
        ...state,
        proLoadings: false,
        getIdProductList: payload,
        proErrors: '',
      };
    case USER_ID_PRODUCTIVITY_FAIL:
      return {
        ...state,
        proLoadings: false,
        proErrors: payload,
        getIdProductList: [],
      };
    default:
      return state;
  }
};

export const todayProductivityForReportReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TODAY_ALL_FOR_REPORT_PRODUCTIVITY_REQUEST:
      return {
        ...state,
        proTodayForReportLoadings: true,
      };
    case USER_TODAY_ALL_FOR_REPORT_PRODUCTIVITY_SUCCESS:
      return {
        ...state,
        proTodayForReportLoadings: false,
        proTodayForReportList: payload,
        proTodayForReportErrors: '',
      };
    case USER_TODAY_ALL_FOR_REPORT_PRODUCTIVITY_FAIL:
      return {
        ...state,
        proTodayForReportLoadings: false,
        proTodayForReportErrors: payload,
        proTodayForReportList: [],
      };
    default:
      return state;
  }
};

export const prevProductReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_PREV_PRODUCTIVITY_REQUEST:
      return {
        ...state,
        prevProLoadings: true,
      };
    case USER_PREV_PRODUCTIVITY_SUCCESS:
      return {
        ...state,
        prevProLoadings: false,
        getPrevProductList: payload,
        prevProErrors: '',
      };
    case USER_PREV_PRODUCTIVITY_FAIL:
      return {
        ...state,
        prevProLoadings: false,
        prevProErrors: payload,
        getPrevProductList: [],
      };
    default:
      return state;
  }
};

export const productMonthReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_MONTH_PRODUCTIVITY_REQUEST:
      return {
        ...state,
        userLoading: true,
      };
    case USER_MONTH_PRODUCTIVITY_SUCCESS:
      return {
        ...state,
        userLoading: false,
        MonthProductList: payload,
        userError: '',
      };
    case USER_MONTH_PRODUCTIVITY_FAIL:
      return {
        ...state,
        userLoading: false,
        userError: payload,
        MonthProductList: [],
      };
    default:
      return state;
  }
};

export const productAllTodayReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TODAY_ALL_PRODUCTIVITY_REQUEST:
      return {
        ...state,
        allTodayProLoading: true,
      };
    case USER_TODAY_ALL_PRODUCTIVITY_SUCCESS:
      return {
        ...state,
        allTodayProLoading: false,
        allTodayProList: payload,
        allTodayProError: '',
      };
    case USER_TODAY_ALL_PRODUCTIVITY_FAIL:
      return {
        ...state,
        allTodayProLoading: false,
        allTodayProError: payload,
        allTodayProList: [],
      };
    default:
      return state;
  }
};

export const productAllMonthReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_MONTH_ALL_PRODUCTIVITY_REQUEST:
      return {
        ...state,
        allMonthProLoading: true,
      };
    case USER_MONTH_ALL_PRODUCTIVITY_SUCCESS:
      return {
        ...state,
        allMonthProLoading: false,
        allMonthProList: payload,
        allMonthProError: '',
      };
    case USER_MONTH_ALL_PRODUCTIVITY_FAIL:
      return {
        ...state,
        allMonthProLoading: false,
        allMonthProError: payload,
        allMonthProList: [],
      };
    default:
      return state;
  }
};
